import React, { useState } from "react";
import { Col, Form, InputGroup, Alert, Button } from 'react-bootstrap';
import emailjs from "emailjs-com";
import { useForm } from "react-hook-form";

const ContactForm = () => {
    const [contactSuccess, changeContactSuccess] = useState(false);
    const [contactLoading, changeContactLoading] = useState(false);
    const [contactError, changeContactError] = useState(false);
  
    const sendEmail = (e) => {
      e.preventDefault();
      changeContactLoading(true);
      changeContactSuccess(false);
      changeContactError(false);
        emailjs.sendForm(
          process.env.GATSBY_EMAILJS_SERVICE_ID,
          process.env.GATSBY_EMAILJS_TEMPLATE_ID,
          e.target,
          process.env.GATSBY_EMAILJS_USER_ID
        )
        .then(
          (result) => {
            changeContactSuccess(true);
          },
          (error) => {
            changeContactError(true);
            changeContactLoading(false);
          }
        );
    };
  
  
    return (
        <div className="segment white">
        <Form onSubmit={sendEmail} className="contact-form">
              <Form.Row>
                <Form.Group
                  as={Col}
                  sm="12"
                  lg="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    id="from_name"
                    name="from_name"
                    type="text"
                    placeholder="Bruce Banner"
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} sm="12" lg="6" controlId="user_name">
                  <Form.Label>Email Address</Form.Label>

                  <InputGroup>
                    <Form.Control
                      id="reply_to"
                      name="reply_to"
                      type="email"
                      placeholder="tony.stark@starkindustries.com"
                      required
                    />
                  </InputGroup>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} sm="12" lg="6" controlId="user_number">
                  <Form.Label>Contact Number</Form.Label>

                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon1">+44</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name="contact_number"
                      id="contact_number"
                      type="tel"
                      required
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group
                  as={Col}
                  sm="12"
                  lg="6"
                  controlId="user_name_hdyhau"
                >
                  <Form.Label>How did you hear about us?</Form.Label>
                  <Form.Control as="select" name="channel" id="channel">
                    <option value="Friend / Family Member">
                      Friend / Family Member
                    </option>
                    <option>Web Search</option>
                    <option>Social Media</option>
                    <option>Online (Other)</option>
                    <option>Client Referral</option>
                  </Form.Control>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md="12" controlId="user_number">
                  <Form.Label>Additional Information</Form.Label>

                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      id="message_html"
                      name="message_html"
                      type="text"
                      rows="5"
                      placeholder="Wake up Link."
                      required
                    />
                  </InputGroup>
                </Form.Group>
              </Form.Row>

              <Form.Row>
              {contactError && (
                <Alert variant="danger">
                  <Alert.Heading>Uh oh...</Alert.Heading>
                  <p>
                    There has been an error - try again later or give us a call
                  </p>
                </Alert>
              )}
              {contactSuccess && (
                <Alert variant="success">
                  <Alert.Heading>Contact form successful, your message has been sent.</Alert.Heading>
                  <p>
                    Thanks for contacting ycgaming.co.uk, we will respond to you as
                    soon as we can.
                  </p>
                </Alert>
              )}
                <Form.Group controlId="exampleForm.Button">
                  <Form.Control
                    type="hidden"
                    name="website_url"
                    value="ycgaming.co.uk"
                  />

                  <Button type="submit" className="light">Send Message</Button>
                </Form.Group>
              </Form.Row>
            </Form>
        </div>
    );
  };

export default ContactForm;